import {
  FetchKycV2RecordResponse,
  FetchKycV2RecordsRequest,
  FetchKycV2RecordsResponse,
  KycV2ModuleActionRequest,
  KycV2ModuleActionResponse,
  UpdateDiditFeatureStatusRequest,
  UpdateDiditFeatureStatusResponse,
} from "@services/models/Kyc/KycV2Models";
import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";

class KycV2ApiService {
  private api: AxiosInstance;

  constructor() {
    this.api = createApiClient();
  }

  public async fetchRecords(
    data?: FetchKycV2RecordsRequest,
  ): Promise<FetchKycV2RecordsResponse> {
    try {
      const params: Record<string, any> = {};
      if (data) {
        params.page = data.page;
        params.limit = data.limit;
        if (data.userId != null && data.userId !== "") {
          params.userId = data.userId;
        }
        if (data.email) {
          params.email = data.email;
        }
        if (data.overallKycStatus) {
          params.overallKycStatus = data.overallKycStatus;
        }
        if (data.basicStatus) {
          params.basicStatus = data.basicStatus;
        }
        if (data.poiStatus) {
          params.poiStatus = data.poiStatus;
        }
        if (data.poaStatus) {
          params.poaStatus = data.poaStatus;
        }
        if (data.amlStatus) {
          params.amlStatus = data.amlStatus;
        }
        if (data.livenessStatus) {
          params.livenessStatus = data.livenessStatus;
        }
      }

      const response = await this.api.get<FetchKycV2RecordsResponse>(
        "/adminPanel/kycV2/records",
        { params },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async fetchRecord(
    userId: number | string,
  ): Promise<FetchKycV2RecordResponse> {
    try {
      const response = await this.api.get<FetchKycV2RecordResponse>(
        `/adminPanel/kycV2/record/${encodeURIComponent(String(userId))}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async approveModule(
    data: KycV2ModuleActionRequest,
  ): Promise<KycV2ModuleActionResponse> {
    try {
      const response = await this.api.post<KycV2ModuleActionResponse>(
        "/adminPanel/kycV2/approve",
        {
          userId: data.userId,
          module: data.module,
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async rejectModule(
    data: KycV2ModuleActionRequest,
  ): Promise<KycV2ModuleActionResponse> {
    try {
      const response = await this.api.post<KycV2ModuleActionResponse>(
        "/adminPanel/kycV2/reject",
        {
          userId: data.userId,
          module: data.module,
          ...(data.reason ? { reason: data.reason } : {}),
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async needsReviewModule(
    data: KycV2ModuleActionRequest,
  ): Promise<KycV2ModuleActionResponse> {
    try {
      const response = await this.api.post<KycV2ModuleActionResponse>(
        "/adminPanel/kycV2/needsReview",
        {
          userId: data.userId,
          module: data.module,
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async updateDiditFeatureStatus(
    data: UpdateDiditFeatureStatusRequest,
  ): Promise<UpdateDiditFeatureStatusResponse> {
    try {
      const response = await this.api.post<UpdateDiditFeatureStatusResponse>(
        "/adminPanel/kycV2/updateDiditFeatureStatus",
        {
          userId: data.userId,
          module: data.module,
          ...(data.reason ? { reason: data.reason } : {}),
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async resetModule(
    data: KycV2ModuleActionRequest,
  ): Promise<KycV2ModuleActionResponse> {
    try {
      const response = await this.api.post<KycV2ModuleActionResponse>(
        "/adminPanel/kycV2/reset",
        {
          userId: data.userId,
          module: data.module,
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const kycV2Service = new KycV2ApiService();
